import { z } from 'zod';

import { i18n } from '@/lib/i18n';

const MIN_REQUIRED_FIELD_VALUE_LENGTH = 1;

const getRequiredStringFiledSchema = (field: string) =>
  z.string().min(MIN_REQUIRED_FIELD_VALUE_LENGTH, i18n.t('required-field', { field }));

export const getCreateEstateSchema = () =>
  z.object({
    estateData: z.object({
      name: getRequiredStringFiledSchema(i18n.t('name')),
      marketType: z.string(),
      propertyType: z.string(),
      propertyLevel: z.string(),
      tenantId: getRequiredStringFiledSchema(i18n.t('tenant')),
      projectId: z.string().optional(),
      creatorId: z.string().optional(),
    }),
    addressData: z.object({
      addressAutoComplete: z.string().optional(),
      address: getRequiredStringFiledSchema(i18n.t('address')),
      houseNumber: getRequiredStringFiledSchema(i18n.t('houseNumber')),
      street: getRequiredStringFiledSchema(i18n.t('street')),
      postalCode: getRequiredStringFiledSchema(i18n.t('postalCode')),
      city: getRequiredStringFiledSchema(i18n.t('city')),
      countryId: getRequiredStringFiledSchema(i18n.t('country')),
      lat: z.number().optional(),
      long: z.number().optional(),
    }),
  });

export type EstateSchemaType = z.infer<ReturnType<typeof getCreateEstateSchema>>;
